import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { Check, ShieldCheck, Truck, Lock, Gift } from 'lucide-react';
const IMAGES = {
  packshot: 'https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png'
};
const CHECKOUT_URLS = {
  pack1: 'https://glowliftessence.com/checkouts/cn/hWN7sPVSvMi4zxKTXeJWh34s/en-us?_r=AQABAO7S3Zf1q2EhPhM7vDxCJ0i0aZLrRNWqM759FB5Cpfs&preview_theme_id=150187475134&skip_shop_pay=true',
  pack3: 'https://glowliftessence.com/checkouts/cn/hWN7sPYv7OcF413jxOpAZfuc/en-us?_r=AQABbWvUEFPW3jyRCWMZge-5-WTHq0s69cHBGuv2CIWCbcY&preview_theme_id=150187475134&skip_shop_pay=true',
  pack5: 'https://glowliftessence.com/checkouts/cn/hWN7sPagPT5iYqy5Sx2LdHH8/en-us?_r=AQABaVuEDBBWWXkq_a4TRf2ZdkroI6zL0pfMdyV7YZXk7Ps&preview_theme_id=150187475134&skip_shop_pay=true'
};
export function PricingSection() {
  return <section id="pricing" className="py-20 bg-gradient-to-b from-white to-blue-50" data-id="element-279">
      <Container data-id="element-280">
        {/* Emotional Justification */}
        <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-281">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-282">
            How much is sleeping in separate rooms really costing your
            relationship?
          </h2>
          <div className="space-y-2 text-lg text-gray-600" data-id="element-283">
            <p data-id="element-284">One dinner date costs more than SnoreStop™.</p>
            <p data-id="element-285">One hotel night costs more than SnoreStop™.</p>
            <p className="font-semibold text-gray-900" data-id="element-286">
              One argument costs more than SnoreStop™.
            </p>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-287">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-288">
            Choose Your Package & Start Sleeping Peacefully Tonight
          </h2>
          <p className="text-xl text-gray-600" data-id="element-289">
            Most customers choose the 3-pack for backup and to share with family
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-end" data-id="element-290">
          {/* Bundle 1 */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 flex flex-col items-center relative z-0" data-id="element-291">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-292">Try It Out</h3>
            <div className="text-gray-500 mb-4" data-id="element-293">1x SnoreStop™</div>
            <div className="h-32 flex items-center justify-center mb-4" data-id="element-294">
              <img src={IMAGES.packshot} alt="1 Pack" className="max-h-full max-w-full object-contain" data-id="element-295" />
            </div>

            <div className="mb-6 text-center" data-id="element-296">
              <div className="text-gray-400 line-through text-lg" data-id="element-297">$79</div>
              <div className="text-4xl font-bold text-gray-900" data-id="element-298">$49</div>
              <div className="text-green-600 font-bold text-sm mt-1" data-id="element-299">
                Save 38%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-sm text-gray-600" data-id="element-300">
              <li className="flex items-center" data-id="element-301">
                <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-302" /> 1 SnoreStop™
                Mouthpiece
              </li>
              <li className="flex items-center" data-id="element-303">
                <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-304" /> Travel Case
              </li>
              <li className="flex items-center" data-id="element-305">
                <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-306" /> Fitting
                Instructions
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-307">
                <Gift className="w-4 h-4 text-blue-600 mr-2" data-id="element-308" />
                FREE Sleep Guide ($19 Value)
              </li>
            </ul>

            <Button fullWidth variant="outline" onClick={() => window.location.href = CHECKOUT_URLS.pack1} data-id="element-309">
              Order 1-Pack Now
            </Button>
          </div>

          {/* Bundle 2 - Best Value */}
          <div className="bg-white rounded-2xl shadow-2xl border-2 border-blue-600 p-8 flex flex-col items-center relative z-10 transform md:-translate-y-4" data-id="element-310">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-311">
              ⭐ Best Value - Most Popular
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2 mt-4" data-id="element-312">
              Best for Couples
            </h3>
            <div className="text-gray-500 mb-4" data-id="element-313">3x SnoreStop™</div>

            <div className="h-36 flex items-center justify-center mb-4" data-id="element-314">
              <div className="flex justify-center -space-x-4" data-id="element-315">
                <img src={IMAGES.packshot} alt="Pack" className="max-h-32 object-contain" data-id="element-316" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-32 object-contain" data-id="element-317" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-32 object-contain" data-id="element-318" />
              </div>
            </div>

            <div className="mb-6 text-center" data-id="element-319">
              <div className="text-gray-400 line-through text-xl" data-id="element-320">$189</div>
              <div className="text-5xl font-bold text-gray-900" data-id="element-321">$117</div>
              <div className="text-green-600 font-bold text-sm mt-1 bg-green-100 px-3 py-1 rounded-full" data-id="element-322">
                Save 38%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-gray-700" data-id="element-323">
              <li className="flex items-center" data-id="element-324">
                <Check className="w-5 h-5 text-green-500 mr-2" data-id="element-325" /> 3 SnoreStop™
                Mouthpieces
              </li>
              <li className="flex items-center" data-id="element-326">
                <Check className="w-5 h-5 text-green-500 mr-2" data-id="element-327" /> 3 Travel Cases
              </li>
              <li className="flex items-center" data-id="element-328">
                <Check className="w-5 h-5 text-green-500 mr-2" data-id="element-329" /> Fitting
                Instructions
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-330">
                <Gift className="w-5 h-5 text-blue-600 mr-2" data-id="element-331" />
                FREE Sleep Guide ($19 Value)
              </li>
              <li className="text-xs text-gray-500 ml-7" data-id="element-332">
                "7 Habits to Stop Snoring Naturally"
              </li>
            </ul>

            <Button fullWidth variant="primary" size="lg" className="animate-pulse" onClick={() => window.location.href = CHECKOUT_URLS.pack3} data-id="element-333">
              Order 3-Pack Now
            </Button>
          </div>

          {/* Bundle 3 */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 flex flex-col items-center relative z-0" data-id="element-334">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-800 text-white px-4 py-1 rounded-full text-sm font-bold uppercase" data-id="element-335">
              Maximum Savings
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2 mt-2" data-id="element-336">
              Family Pack
            </h3>
            <div className="text-gray-500 mb-4" data-id="element-337">5x SnoreStop™</div>

            <div className="h-32 flex items-center justify-center mb-4" data-id="element-338">
              <div className="flex justify-center -space-x-6" data-id="element-339">
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-340" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-341" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-342" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-343" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-344" />
              </div>
            </div>

            <div className="mb-6 text-center" data-id="element-345">
              <div className="text-gray-400 line-through text-lg" data-id="element-346">$299</div>
              <div className="text-4xl font-bold text-gray-900" data-id="element-347">$169</div>
              <div className="text-green-600 font-bold text-sm mt-1" data-id="element-348">
                Save 43%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-sm text-gray-600" data-id="element-349">
              <li className="flex items-center" data-id="element-350">
                <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-351" /> 5 SnoreStop™
                Mouthpieces
              </li>
              <li className="flex items-center" data-id="element-352">
                <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-353" /> 5 Travel Cases
              </li>
              <li className="flex items-center" data-id="element-354">
                <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-355" /> Fitting
                Instructions
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-356">
                <Gift className="w-4 h-4 text-blue-600 mr-2" data-id="element-357" />
                FREE Sleep Guide ($19 Value)
              </li>
            </ul>

            <Button fullWidth variant="outline" onClick={() => window.location.href = CHECKOUT_URLS.pack5} data-id="element-358">
              Order 5-Pack Now
            </Button>
          </div>
        </div>

        {/* Urgency & Trust */}
        <div className="mt-12 text-center space-y-4" data-id="element-359">
          <p className="text-red-600 font-semibold text-lg" data-id="element-360">
            Due to high demand and small-batch production, we can only ship a
            limited number of SnoreStop™ units per day.
          </p>
          <p className="text-blue-900 font-bold text-xl" data-id="element-361">
            Order now to start sleeping together again this week.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-gray-500 text-sm pt-4" data-id="element-362">
            <span className="flex items-center" data-id="element-363">
              <Lock className="w-4 h-4 mr-1" data-id="element-364" /> Secure Checkout
            </span>
            <span className="flex items-center" data-id="element-365">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-366" /> 60-Day Guarantee
            </span>
            <span className="flex items-center" data-id="element-367">
              <Truck className="w-4 h-4 mr-1" data-id="element-368" /> Fast Shipping
            </span>
          </div>
        </div>
      </Container>
    </section>;
}